var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

/**
 *
 * @param
 */
var PlacingStateMachine = function (root, editorModel, selectionModel, multiplePlacing, elementsToPlaceSet) {
    var self = this;

    this.root = root;
    this.editorModel = editorModel;
    this.selectionModel = selectionModel;

    this.placedElements = new lib_core.Collections.HashSet();
    this.elementsToPlace = elementsToPlaceSet || new lib_core.Collections.HashSet();

    lib_core.StateMachine.call(this);

    function mouseMoveTransition(cEvent) {
        var keys = {altKey: cEvent.data('altKey'), shiftKey: cEvent.data('shiftKey')};
        var snapVec = self.editorModel.getSnappedMouseDisplacement(self.elementsToPlace);
        self.elementsToPlace.forEach(function(element) {
            element.move(snapVec, {});
        });
    }

    this.addTransition("idle","placing",
        function(cEvent) {
            return cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_MOVE;
        },
        mouseMoveTransition
    );

    this.addTransition("placing","placing",
        function(cEvent) {
            return cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_MOVE;
        },
        mouseMoveTransition
    );

    this.addTransition("placing","idle",
        function(cEvent) {
            return (cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_UP);
        },
        function (cEvent) {
            self.root.stopRec();
            if(self.elementsToPlace.size())
                self.placedElements.addAll(self.elementsToPlace);
            self.elementsToPlace.removeAll();

            if(multiplePlacing) self.enterFunction();
            else {
                self.selectionModel.addAllToSelection(self.placedElements);
                self.placedElements.removeAll();
                self.handle(cEvent);
            }
            self.editorModel.clearSnap();
        }
    );

    this.addTransition("placing","idle",
        function(cEvent) {
            return (cEvent.isKeyPressed("escape") || cEvent.type().isGuiButton);
        },
        function (cEvent) {
            self.handle(cEvent);
        }
    );

    this.addEventAction("idle",
        function(cEvent) {
            return (cEvent.isKeyPressed("escape") || cEvent.type().isGuiButton);
        },
        function (cEvent) {
            self.root.cancelRec();
            self.selectionModel.addAllToSelection(self.placedElements);
            self.placedElements.removeAll();
            self.elementsToPlace.removeAll();
            self.editorModel.clearSnap();
        }
    );
};

lib_core.inherit(PlacingStateMachine, lib_core.StateMachine);

module.exports = PlacingStateMachine;

PlacingStateMachine.prototype.createElement = function () {
    throw new Error("createElement function should be implemented by the inheriting state machine");
};

PlacingStateMachine.prototype.enterFunction = function (cEvent) {
    this.root.rec();
    var startCoord = this.editorModel.mousePos();
    var interactionModel = this.createElement(startCoord);
    this.elementsToPlace.add(interactionModel);

    this.selectionModel.emptySelection();
    this.selectionModel.addAllToSelection(this.elementsToPlace);
};
